import { render, staticRenderFns } from "./account-delete.vue?vue&type=template&id=762bd34c"
import script from "./account-delete.vue?vue&type=script&lang=js"
export * from "./account-delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports